<template>
	<v-dialog
		v-model="$store.state.loader"
		persistent
		width="300"
	>
		<v-card
			color="primary"
			dark
		>
			<v-card-text
				class="hidden-print-only">
				Proszę czekać...
				<v-progress-linear
					indeterminate
					color="white"
					class="mb-0"
				></v-progress-linear>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name: "loader",
	};
</script>

<style scoped>

</style>
